import { NgRedux } from '@angular-redux/store';
import { Injectable, Inject } from '@angular/core';
import { DataTransformService, ProductCategory } from '@ridango/core';
import { TravellersState } from './store/traveller.store';
import { TravellerActions } from './actions/traveller.actions';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable( {
    providedIn: 'root'
} )
export class TravellerService {


    constructor(
        @Inject( 'ENV' ) private env: any,
        private http: HttpClient,
        private ngRedux: NgRedux<TravellersState>,
        private actions: TravellerActions,
        private dataTransformer: DataTransformService
    ) { }


    fetchTravellerCategories ( regionId: number ) {
        console.log( 'DEPRECATED: TravellerService : fetchTravellerCategories' );

        // this.ngRedux.dispatch( this.actions.categoriesFetchStart() );
        // this.coreHttp.get( `${this.env.API_BASE_URL}/${this.env.REGION_ID}/categories` )
        //     .map( data => data.json() )
        //     .subscribe(
        //         data => {
        //             this.ngRedux.dispatch( this.actions.categoriesFetchSuccess( null ) );
        //             let normalizedTravellers: any = {};
        //             const categoryIds = data.filter( t => t.type === 'traveller' )
        //                 .sort( ( a, b ) => a.keyword > b.keyword ? 1 : a.keyword < b.keyword ? - 1 : 0 )
        //                 .map( t => {
        //                     normalizedTravellers = { ...normalizedTravellers, [ t.id ]: t };
        //                     return t.id;
        //                 } );
        //             // tslint:disable-next-line:max-line-length
        //             this.ngRedux.dispatch( this.actions.setTravellerCategories( { categoryIds: categoryIds, categories: normalizedTravellers } ) );
        //         },
        //         err => {
        //             this.ngRedux.dispatch( this.actions.categoriesFetchFailed( err ) );
        //             throw new Error( 'Traveller categories fetch failed' );
        //         },
        //         () => {
        //             this.ngRedux.dispatch( this.actions.categoriesFetchEnd() );
        //         }
        //     );
    }

    fetchTravellerCategoriesRequest (): Observable<any> {
        return this.http.get( `${this.env.API_BASE_URL}/${this.env.REGION_ID}/categories` )
            .pipe(
                map( ( d: any ) => {
                    return d.filter( t => t.type === 'traveller' )
                        .sort( ( a, b ) => a.keyword > b.keyword ? 1 : a.keyword < b.keyword ? - 1 : 0 );
                } )
            );
    }

    setAllCategories ( categories: ProductCategory[] ) {
        this.ngRedux.dispatch( this.actions.setAllTravellerCategories( categories ) );
    }

    setSelectedTravellerCategoryId ( categoryId: any ) {
        this.ngRedux.dispatch( this.actions.setSelectedCategory( categoryId ) );
    }

    setSelectedTravellerCategoryObj ( category: ProductCategory ) {
        this.ngRedux.dispatch( this.actions.setSelectedCategoryObj( category ) );
    }
}
